query Pricelists($brandID: ID!, $archived: Boolean) {
    pricelists(brandID: $brandID, archived: $archived) {
        id
        brandID
        name(language: "en") { language text }
        currency
        countries
        defaultForCountries
        valid { from to }
        archived
        productCount
    }
}
